<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  created () {
    window.localStorage.clear()
    // 判断是否有查询
    if (window.location.href.indexOf('?') !== -1) {
      // 获取查询参数
      let searchs = window.location.href.split('?')[1]
      if (window.location.href.indexOf('&') !== -1) {
        searchs = window.location.href.split('?')[1].split('&')
        searchs.forEach((item) => {
          let obj = item.split('=')
          if (obj[1].indexOf('#') !== -1) {
            obj[1] = obj[1].split('#')[0]
          }
          window.localStorage.setItem(obj[0], obj[1])
        })
      } else {
        let obj = searchs.split('=')
        window.localStorage.setItem(obj[0], obj[1])
      }
    }
    document.body.className = window.localStorage.getItem('theme') || 'custom-grayBlue'
    // 判断是否有需要跳转的
    if (window.localStorage.getItem('to') !== undefined) {
      this.$router.push({ name: window.localStorage.getItem('to'), query: { taskId: window.localStorage.getItem('taskId') } })
    }
  }
}
</script>

<style lang="scss">
.app-container{
  height: 100vh!important;
}
</style>
